/**
 * Format money values based on your shop currency settings
 * @param  {Number} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
export const formatMoney = (cents: number, format: string = '${{amount}}') => {
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  const formatWithDelimiters = (
    cents: number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ): string => {
    if (isNaN(cents) || cents == null) {
      return '0';
    }

    const centsString = (cents / 100.0).toFixed(precision);
    const parts = centsString.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  const formatMap: {
    [key: string]: () => string;
  } = {
    amount: () => formatWithDelimiters(cents, 2),
    amount_no_decimals: () => formatWithDelimiters(cents, 0),
    amount_with_comma_separator: () => formatWithDelimiters(cents, 2, '.', ','),
    amount_no_decimals_with_comma_separator: () => formatWithDelimiters(cents, 0, '.', ',')
  }
  const value: string = formatMap[format.match(placeholderRegex)[1]]()

  return format.replace(placeholderRegex, value);
}

export const getDistance = (lat1 : number, lon1 : number, lat2 : number, lon2 : number, unit : string) : number => {
	if ((lat1 == lat2) && (lon1 == lon2)) {
		return 0;
	}
	else {
		var radlat1 = Math.PI * lat1/180;
		var radlat2 = Math.PI * lat2/180;
		var theta = lon1-lon2;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		if (dist > 1) {
			dist = 1;
		}
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		if (unit=="K") { dist = dist * 1.609344 }
		if (unit=="N") { dist = dist * 0.8684 }
		return dist;
	}
}

export const stripHTML = (html: string) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export const extractLat = (url: string) : number => {
    const Lat = /\@(-?[\d\.]*)/.exec(url)
    return Lat ? parseFloat(Lat[1]) : null
}

export const extractLng = (url: string) : number => {
    const Lng = /\@[-?\d\.]*\,([-?\d\.]*)/.exec(url)
    return Lng ? parseFloat(Lng[1]) : null
}